module.exports = __webpack_public_path__ + "assets/img/logo.e2a49dfd.png";